import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/DIF_LOGO_flerfarvede_ringe.png'


const _withScopeId = n => (_pushScopeId("data-v-6bb195a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"outer-container\" data-v-6bb195a6><div class=\"content-box\" data-v-6bb195a6><span class=\"heading\" data-v-6bb195a6><span class=\"highlight\" data-v-6bb195a6>Den Danske Billard Union </span>er medlem af </span><div class=\"box\" data-v-6bb195a6><a href=\"https://www.dif.dk/\" target=\"_blank\" rel=\"noreferrer noopener\" title=\"DIF\" data-v-6bb195a6><img src=\"" + _imports_0 + "\" alt=\"Danmarks Idrætsforbund\" height=\"100\" data-v-6bb195a6></a></div></div></div>", 1)
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "medlem_af",
  style: {"background-color":"rgb(3, 3, 3)"}
}, [
  /*#__PURE__*/_createElementVNode("p", { class: "membershipHeadline center" }, "Den Danske Billard Union · Idrættens Hus · Brøndby Stadion 20 · 2605 Brøndby · E-mail ddbu@ddbu.dk · CVR xxxxxxxx")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChatBot = _resolveComponent("ChatBot")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_ChatBot),
    _hoisted_3
  ]))
}